import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';


import Layout from './Components/Layout/index.js';
import MainHomePage from './screens/Home/MainHomePage.js';
import Profile from "./screens/Profile/index.js";


import NotFound from './screens/NotFound/index.js';
import ProtectedRoute from './Components/Hoc/ProtectedRoutes.js';
import AdminProtectedRoute from './Components/Hoc/AdminProtectedRoutes.js';
import ProductionManagerProtectedRoute from './Components/Hoc/ProductionManagerProtectedRoutes.js';
import SuperAdminProtectedRoute from './Components/Hoc/SuperAdminProtectedRoutes.js';
import StockManagerProtectedRoute from './Components/Hoc/StockManagerProtectedRoutes.js';

import ProductionManagerLayout from './Components/ProductionManagerLayout/ProductionManagerLayout.js';
import ProductionDashboard from './screens/ProductionManager/ProductionDashboard.js';
import ProductionOrdersManagement from './screens/ProductionManager/ProductionOrdersManagement.js';

import StockManagerLayout from './Components/StockManagerLayout/StockManagerLayout.js';
import Stockmanagement from './screens/StockManager/StockManagement.js';
import ShortageDamage from './screens/StockManager/ShortageDamage.js';

// admin screens
import Dashboard from './screens/AdminPanel/Dashboard.jsx';
import OrdersManagement from './screens/AdminPanel/OrdersManagement.jsx';
import AdminLayout from './Components/AdminLayout/AdminLayout.js';
import DamageShortage from './screens/AdminPanel/DamageShortage.jsx';
import MachineManagement from './screens/AdminPanel/MachineManagement.jsx';
import UserManagement from './screens/AdminPanel/UserManagement.jsx';
import ProductionTracking from './screens/AdminPanel/ProductionTracking.jsx';
import StockManagement from './screens/AdminPanel/StockManagement.jsx';
import MachineRawMaterialMapping from './screens/AdminPanel/MachineRawMaterialMapping.jsx';

// super admin routes
import SuperAdminLayout from './Components/SuperAdminLayout/index.js';
import SuperAdminDashboard from './screens/SuperAdmin/SuperAdminDashboard.js';
import SuperAdminUserManagement from './screens/SuperAdmin/SuperAdminUserManagement.js';

import TermsConditions from './screens/termsandcondition/terms.js';
import About from './screens/termsandcondition/About.js';
import Privacy from './screens/termsandcondition/privacy.js';
import Contact from './screens/termsandcondition/contactus.js';
import PricingPolicy from './screens/termsandcondition/PricingPolicy.jsx';
import SuperAdminSubscriptionManagement from './screens/SuperAdmin/SuperAdminSubscriptionManagement.js';

function App() {
  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Layout />}>
          <Route path='/' element={<MainHomePage />} />
          <Route path="/profile" element={<ProtectedRoute component={Profile} />} />
        </Route>


        {/* production manager routes */}
        <Route path="/productionmanager" element={<ProductionManagerProtectedRoute component={ProductionManagerLayout} />}>
          <Route index element={<Navigate to="/productionmanager/dashboard" replace />} />
          <Route path="dashboard" element={<ProductionManagerProtectedRoute component={ProductionDashboard} />} />
          <Route path="orders-management" element={<ProductionManagerProtectedRoute component={ProductionOrdersManagement} />} />
          <Route path='profile' element={<ProductionManagerProtectedRoute component={Profile} />} />
        </Route>


        {/* stock manager routes */}
        <Route path="/storemanager" element={<StockManagerProtectedRoute component={StockManagerLayout} />}>
          <Route index element={<Navigate to="/storemanager/stockmanagement" replace />} />
          <Route path="stockmanagement" element={<StockManagerProtectedRoute component={Stockmanagement} />} />
          <Route path="shortage-damage" element={<StockManagerProtectedRoute component={ShortageDamage} />} />
          <Route path='profile' element={<StockManagerProtectedRoute component={Profile} />} />
        </Route>


        {/* Admin Routes */}
        <Route path="/admin" element={<AdminProtectedRoute component={AdminLayout} />}>
          <Route index element={ <Navigate to="/admin/dashboard" replace />} />
          <Route path="dashboard" element={<AdminProtectedRoute component={Dashboard} />} />
          <Route path="orders" element={<AdminProtectedRoute component={OrdersManagement} />} />
          <Route path="damage-shortage" element={<AdminProtectedRoute component={DamageShortage} />} />
          <Route path="machine-management" element={<AdminProtectedRoute component={MachineManagement} />} />
          <Route path="user-management" element={<AdminProtectedRoute component={UserManagement} />} />
          <Route path="production-tracking" element={<AdminProtectedRoute component={ProductionTracking} />} />
          <Route path="stock-management" element={<AdminProtectedRoute component={StockManagement} />} />
          <Route path='profile' element={<AdminProtectedRoute component={Profile} />} />
          <Route path='machine-raw-material-mapping' element={<AdminProtectedRoute component={MachineRawMaterialMapping} />} />
        </Route>

        {/* Super Admin Routes */}
        <Route path="/superAdmin" element={<SuperAdminProtectedRoute component={SuperAdminLayout} />}>
          <Route index element={<Navigate to="/superAdmin/dashboard" replace />} />
          <Route path="dashboard" element={<SuperAdminProtectedRoute component={SuperAdminDashboard} />} />
          <Route path="userManagement" element={<SuperAdminProtectedRoute component={SuperAdminUserManagement} />} />
          <Route path="profile" element={<SuperAdminProtectedRoute component={Profile} />} />
          <Route path="subscriptionManagement" element={<SuperAdminProtectedRoute component={SuperAdminSubscriptionManagement} />} />
        </Route>

        <Route path='/about' element={<About />}>

          <Route path='terms' element={<TermsConditions />} />
          <Route path='contact' element={<Contact />} />
          <Route path='privacy' element={<Privacy />} />
          <Route path='pricing' element={<PricingPolicy />} />
        </Route>

        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router >
  );
}
export default App;
